import React, { Component } from 'react';
import QuoteSlider from './QuotoSlider';
export class Home extends Component {
  static displayName = Home.name;

  constructor(props) {
    super(props);
    this.state = {
      modalOpen: true   // modal visible on load
    };
  }

  closeModal = () => {
    this.setState({ modalOpen: false });
  };

  render () {
    return (
      <div>
        <section className="hero">
          <div className="card">
            <h1 title="Swami Brahmanand Saraswati">स्वामी ब्रह्मानंद सरस्वती जी महाराज</h1>
            <p className="lead">
            <b>स्वामी ब्रह्मानंद सरस्वती जी महाराज (1909 – 2021)</b> भारत के महान संतों में से एक थे, जिन्होंने अपने जीवन को धर्म, ध्यान और मानव सेवा के आदर्शों के लिए समर्पित कर दिया। उनका जन्म बिहार राज्य के जहानाबाद जिला में हुआ था। बचपन से ही वे अध्यात्म के प्रति अत्यंत रुचि रखते थे और बहुत कम उम्र में उन्होंने गृहत्याग कर सत्य की खोज का मार्ग अपनाया। कठोर तप, गहन अध्ययन और निरंतर साधना के माध्यम से उन्होंने वेदांत, उपनिषद, और योगशास्त्र के गूढ़ रहस्यों को आत्मसात किया।
            <br/><br/>
            वे श्री महाकालेश्वर ज्ञान मंदिर आश्रम के अधिष्ठाता रहे — जो आज भी हजारों भक्तों के लिए साधना, भक्ति और आत्मिक जागरण का केंद्र है। स्वामी जी का जीवन सादगी, करुणा और शांति का प्रतीक था। उनकी उपस्थिति से वातावरण में दिव्यता का अनुभव होता था। उन्होंने कहा था कि “सच्ची पूजा मंदिरों में नहीं, हृदय की निर्मलता में होती है।” उनके प्रवचनों ने असंख्य लोगों को जीवन के सच्चे उद्देश्य की ओर प्रेरित किया — आत्मज्ञान, सेवा और ईश्वर से एकत्व की अनुभूति की ओर।
            <br/><br/>
            उनका संपूर्ण जीवन यह सिखाता है कि जब मनुष्य अहंकार छोड़कर प्रेम, करुणा और साधना के मार्ग पर चलता है, तभी उसे परम सत्य का साक्षात्कार होता है।
          </p>
          </div>
          <aside class="card portrait-wrap">
            <img src="images/guruji_image1.jpg" alt="Swami Brahmanand Saraswati Ji Mahara" title="Swami Brahmanand Saraswati" style={{width: "100%",height: "auto",objectFit: "contain",borderRadius: "8px",filter: "drop-shadow(0 30px 80px rgba(0,0,0,0.6))",border: "1px solid rgba(255,255,255,0.03)"}}/>
          </aside>
        </section>

        {/* ⭐ NEW REACT QUOTE SLIDER HERE ⭐ */}
        <QuoteSlider />

        
      <section style={{padding:"6px 0 28px"}}>
        <div className="container">
          <h3 style={{color:"var(--accent)", marginBottom:"12px"}} >Gallery</h3>
          <div className="gallery">
            <img src="images/guruji_photo.jpg" alt="Swami Brahmanand Saraswati" data-large="images/guruji_photo.jpg" title="Swami Brahmanand Saraswati"/>
            <img src="images/guruji_image1.jpg" alt="Swami Brahmanand Saraswati" data-large="images/guruji_image1.jpg" title="Swami Brahmanand Saraswati"/>
            <img src="images/guruji_image5.jpg" alt="Swami Brahmanand Saraswati" data-large="images/guruji_image5.jpg" title="Swami Brahmanand Saraswati"/>
          </div>
        </div>
      </section>

      <section className="container" style={{ marginTop: "60px", marginBottom: "80px" }}>
        <div className="card" style={{ padding: "34px 36px" }}>
          <h2
            style={{
              color: "var(--accent)",
              textAlign: "center",
              fontSize: "clamp(26px,3vw,38px)",
              marginBottom: "18px",
            }}
          title="Swami Brahmanand Saraswati">
            🌼 श्री स्वामी ब्रह्मानंद सरस्वती जी महाराज — जीवन यात्रा और विरासत 🌼
          </h2>

          {/* Profile Section */}
          <div
            style={{
              display: "flex",
              gap: "24px",
              alignItems: "center",
              flexWrap: "wrap",
              marginBottom: "18px",
            }}
          >
            <div style={{ flex: "0 0 220px", textAlign: "center" }}>
              <div
                style={{
                  width: "200px",
                  height: "200px",
                  borderRadius: "50%",
                  overflow: "hidden",
                  margin: "0 auto",
                  border: "4px solid var(--accent)",
                  boxShadow: "0 20px 60px rgba(0,0,0,0.6)",
                }}
              >
                <img
                  src="images/IMG_5427-removebg-preview.png"
                  alt="Swami Brahmanand Saraswati Ji"
                  title="Swami Brahmanand Saraswati"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    display: "block",
                  }}
                />
              </div>
              <div style={{ marginTop: "10px", color: "var(--muted)", fontSize: "13px" }}>
                पूज्य स्वामी ब्रह्मानंद सरस्वती जी
              </div>
            </div>

            <div style={{ flex: 1, minWidth: "260px" }}>
              <p style={{ margin: 0, color: "rgba(255,235,200,0.95)", lineHeight: "1.8" }}>
                <strong title="Swami Brahmanand Saraswati">स्वामी ब्रह्मानंद सरस्वती जी महाराज (1909 – 2021)</strong> का जीवन धर्म,
                तप, सेवा और वेदांत-ज्ञान का अद्वितीय मिश्रण रहा।
                उनका जन्म <strong>वर्ष 1909</strong> में बिहार के जहानाबाद जिले के पोखमा गाँव में
                एक सम्मानित भूमिहार-ब्राह्मण परिवार में हुआ।
                बाल्यावस्था से ही उनमें आत्मिक स्वरूप की ओर उत्कंठा और वीराग्य स्पष्ट था —
                जो उनके संपूर्ण जीवन का आधार बना।
              </p>
            </div>
          </div>

          <hr
            style={{
              border: "none",
              height: "1px",
              background: "rgba(255,255,255,0.03)",
              margin: "18px 0 22px",
            }}
          />

          {/* Two Column Content */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
              gap: "22px",
            }}
          >
            {/* Column 1 */}
            <div>
              <h3 style={{ color: "var(--accent)", margin: "0 0 8px" }}>
                जन्म, परिवार और प्रारम्भिक जीवन
              </h3>
              <p style={{ color: "var(--muted)", lineHeight: "1.78" }}>
                पूज्य गुरुदेव का जन्म बाबू <strong>जगदीश नारायण सिंह</strong> के घर में हुआ — जो उस क्षेत्र के प्रतिष्ठित जमींदार परिवारों में से था। 
          पाँच वर्ष की आयु में ही उनके दादा-गुरु <strong>श्री श्री १०८ परमहंस डंडी स्वामी अद्वैतानन्द सरस्वती जी</strong> ने उन्हें अपने सान्निध्य में लिया। 
          दादा-गुरु के मार्गदर्शन में उनके व्यक्तित्व का आध्यात्मिक और शैक्षिक विकास शीघ्र हुआ। प्रारंभिक संस्कार, वेद-भाष्य और धार्मिक शिक्षाओं का बीज इसी जीवन में बोया गया।
              </p>

              <h3 style={{ color: "var(--accent)", marginTop: "14px" }}>
                शिक्षा, संगीत और न्यायिक जीवन
              </h3>
              <p style={{ color: "var(--muted)", lineHeight: "1.78" }}>
                आगे की शिक्षा के लिए वे <strong>पटना</strong> गए और तत्पश्चात <strong>इलाहाबाद (प्रयागराज)</strong> से विधि में स्नातकोत्तर पूरा किया। 
          शिक्षा के साथ-साथ उनका रुझान संगीत की ओर भी प्रबल था — वे तबला वादन में निपुण हुए और संगीत को आध्यात्मिक साधना का माध्यम मानते थे। 
          एक समय वे <strong>पटना हाई कोर्ट</strong> में न्यायिक दायित्व निभा चुके हैं; परंतु भीतर जन्मे वैराग्य ने उन्हें सांसारिक प्रतिष्ठाओं से अलग कर दिया।
              </p>

              <h3 style={{ color: "var(--accent)", marginTop: "14px" }}>
                विधिवत सन्यास और गुरुकुल
              </h3>
              <p style={{ color: "var(--muted)", lineHeight: "1.78" }}>
                अंततः वे अपने दादा-गुरु के पास लौट आये और विधिवत सन्यास-दीक्षा ग्रहण की। सन्यास लेकर उनका जीवन पूर्णतः साधना, अध्ययन और क्षेत्र-सेवा के लिए समर्पित हो गया। 
          गुरुकुल के आदर्शों पर चलकर उन्होंने शिष्यों का पोषण तथा वेद-तंत्र की शुद्ध परंपरा को आगे बढ़ाया।
              </p>
            </div>

            {/* Column 2 */}
            <div>
              <h3 style={{ color: "var(--accent)", margin: "0 0 8px" }}>
                तपस्या, तीर्थयात्राएँ और साधना
              </h3>
              <p style={{ color: "var(--muted)", lineHeight: "1.78" }}>
                वे देश के अनेक पवित्र तीर्थों में गए — <strong>वासुकीनाथ, माँ कामाख्या (असम), मंगला गौरी (गया), बनखंडी (पटना), काशी-विश्वनाथ, अयोध्या, गोरखनाथ (गोरखपुर), डासना देवी और हरिद्वार</strong> सहित अनेक स्थानों पर उन्होंने दीर्घकालिक तपस्या की। 
          इन साधनाओं में उनका मन दृढ़ होता गया और आत्मिक परिपक्वता प्राप्त हुई। उनके ध्यान-विवेक और तप ने जिस भी क्षेत्र को स्पर्श किया, वहाँ एक दिव्य शांति और अनुशासन का वातावरण बन गया।
              </p>

              <h3 style={{ color: "var(--accent)", marginTop: "14px" }}>
                देववृन्द और महाकाल आश्रम
              </h3>
              <p style={{ color: "var(--muted)", lineHeight: "1.78" }}>
                देववृन्द आने पर उन्होंने भगवान् शंकर और माँ भगवती की कठोर तपस्या की — और यहीं उन्होंने तंत्र-वेदांत को शुद्ध रूप में प्रतिष्ठित किया। 
          महाभारतकालीन साधना भूमि तथा शमशान भूमि को पुनर्जीवित कर उन्होंने <strong>श्री महाकालेश्वर ज्ञान मंदिर आश्रम</strong> की नींव रखी। 
          यह आश्रम आज भी उनकी साधनाशक्ति और आदर्शों का धरोहर है — जहाँ शिष्यों और भक्तों के लिए ज्ञान, सेवा और साधना का सम्पूर्ण वातावरण मिलता है।
              </p>
            </div>
          </div>

          {/* Long Bio Section */}
          <div style={{ marginTop: "22px" }}>
            <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>
              एक जीवनी-कथा: तप से सेवा तक
            </h3>

            <p style={{ color: "var(--muted)", lineHeight: "1.86", textAlign: "justify" }}>
              पूज्य स्वामी ब्रह्मानंद सरस्वती जी का जीवन किसी एक रूप में बन्द नहीं किया जा सकता — यह कई अध्यायों का समेकित अनुभव है। 
        बचपन का वह नन्हा बालक, जिसे दादा-गुरु ने अपने आशीर्वाद से सँभाला, समय के साथ एक स्थिर, गंभीर और सर्वग्राही साधक बन गया। 
        पढ़ाई, संगीत-कला और न्यायिक सेवा के अनुभव ने उनके व्यक्तित्व को व्यापकता दी — परन्तु अंतस में जो शांति की लालसा थी, उसने उन्हें हमेशा एक अलग राह पर खींचा।
            </p>

            <p style={{ color: "var(--muted)", lineHeight: "1.86", textAlign: "justify" }}>
              सन्यास लेने के पश्चात उनका जीवन और भी व्यापक रूप में खुला — वे केवल ध्यान में लीन नहीं रहे, बल्कि उन्होंने समाज की उन जरूरतों को भी देखा जिन्हें धर्म-आधार पर ही सुलझाया जा सकता था। 
        उन्होंने सैकड़ों गौशालाओं की स्थापना की, जहां पवित्र गायों का संरक्षण होता था; उन्होंने संस्कृत-विद्यालय और कन्या-विद्यालय खोले, ताकि शिक्षा और संस्कृति दोनों साथ-साथ चलें; 
        अस्पताल और सेवा-केंद्र स्थापित किए ताकि तात्कालिक दुखों में भी राहत मिल सके। उनका यह दृढ विश्वास था कि आध्यात्मिक प्रगति तभी सार्थक है जब वह समाज के कल्याण में बदल जाए।
            </p>

            <p style={{ color: "var(--muted)", lineHeight: "1.86", textAlign: "justify" }}>
              समय-समय पर उनके जीवन में ऐसे क्षण आये जब आश्चर्यजनक परिवर्तन और चमत्कारिक घटनाएँ उनके अनुयायियों के द्वारा देखी गयीं — रोगों में आराम, कठिन परस्थितियों में आश्चर्यजनक समाधान, तथा भक्तों के हृदयों में अचानक आई आस्था-लहर। 
        पर स्वामी जी स्वयं हमेशा इन घटनाओं को ईश्वर-कृपा मानते थे और स्वयं को उनसे अलग रखते थे। उनका मूल संदेश था — “सब कुछ ईश्वर की कृपा है; साधक केवल समानुभूति और सेवा का पात्र है।”
            </p>

            <p style={{ color: "var(--muted)", lineHeight: "1.86", textAlign: "justify" }}>
              महाकाल आश्रम में बिताये गए वर्षों में उनका उद्देश्य स्पष्ट था — परम्परागत तंत्र-वेदांत को शुद्ध स्वरूप में संजोना, शिष्य-परम्परा को मजबूत करना, और समाज के कमजोर-वर्गों के लिए शिक्षा-सेवा के मार्ग खोलना। 
        इसी दृष्टि से आश्रम आज भी अनेक सामाजिक और धार्मिक कार्य कर रहा है — और स्वामी जी के दिखाये हुए पथ पर कई शिष्य चल रहे हैं।
            </p>

            <p style={{ color: "var(--muted)", lineHeight: "1.86", textAlign: "justify" }}>
              अन्ततः 2021 में उनकी देहावसान-प्राप्ति के बाद भी उनकी शिक्षाएँ, उपदेश और संस्थाएँ जीवित हैं। उनके शिष्यों और अनुयायियों द्वारा उनकी स्मृति में अनेक कार्यक्रम, सेवा-प्रोजेक्ट और साधना-शिविर नियमित रूप से संचालित होते हैं — जिससे उनकी परम्परा आगे भी निरन्तर प्रवाहित रहे।
            </p>
          </div>

          {/* Cards Section */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
              gap: "22px",
            }}
          >
            <div
              className="card"
              style={{
                background: "transparent",
                padding: "18px",
                border: "1px dashed rgba(255,255,255,0.03)",
              }}
            >
              <h4 style={{ color: "var(--accent)", marginTop: "6px" }}>
                प्रमुख कार्य और संस्थाएँ
              </h4>
              <ul
                style={{
                  color: "var(--muted)",
                  lineHeight: "1.7",
                  margin: "8px 0 0 18px",
                }}
              >
                <li>श्री महाकालेश्वर ज्ञान मंदिर आश्रम की स्थापना एवं मार्गदर्शन</li>
                <li>सैकड़ों गौशालाओं का संरक्षण एवं प्रबंधन</li>
                <li>हॉस्पिटल, संस्कृत विद्यालय एवं कन्या शिक्षालयों की स्थापना</li>
                <li>वेद-तंत्र का पुनर्स्थापन और शिष्यों को दीक्षा</li>
                <li>सामाजिक-धार्मिक आंदोलनों में सक्रिय भूमिका (समाज कल्याण हेतु)</li>
              </ul>
            </div>

            <div
              className="card"
              style={{
                background: "transparent",
                padding: "18px",
                border: "1px dashed rgba(255,255,255,0.03)",
              }}
            >
              <h4 style={{ color: "var(--accent)", marginTop: "6px" }}>
                चमत्कार एवं आध्यात्मिक अनुभूतियाँ
              </h4>
              <p style={{ color: "var(--muted)", lineHeight: "1.7", marginTop: "8px" }}>
                भक्तजन और श्रद्धालु अनेक घटनाओं का वृत्तांत सुनाते हैं — रोगों में ठहराव, आपदाओं में आश्चर्यजनक सहायता, और मनोवैज्ञानिक शांति का अनुभव। 
          परन्तु स्वामी जी स्वयं इन चमत्कारों को व्यक्तिगत उपलब्धि नहीं मानते थे; उनका कहना था कि यह सब ईश्वर-कृपा और साधना की परिणामस्वरूप होता है।
              </p>
            </div>
          </div>

          {/* Ashram Image */}
          <div style={{ marginTop: "26px", textAlign: "justify" }}>
            <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>विरासत और अंतिम संदेश</h3>

            <p style={{ color: "var(--muted)", lineHeight: "1.86" }}>
              पूज्य स्वामी ब्रह्मानंद सरस्वती जी का जीवन यह संदेश देता है कि सच्ची आध्यात्मिकता और सामाजिक दायित्व साथ-साथ चलते हैं। 
        उनका उपदेश — “हृदय की निर्मलता ही सच्ची पूजा है” — आज भी अनेक दिलों में दीपक जलाये हुए है। 
        आश्रम-कर्म, शिष्य-परम्परा और सेवाकार्यों के माध्यम से उनकी विरासत आने वाली पीढ़ियों के लिए प्रेरणा बनी रहेगी।
            </p>

            <div style={{ textAlign: "center", marginTop: "20px" }}>
              <img
                src="images/ashram.jpg"
                alt="Mahakaleshwar Ashram"
                style={{
                  width: "88%",
                  borderRadius: "10px",
                  border: "1px solid rgba(255,255,255,0.03)",
                  boxShadow: "0 30px 80px rgba(0,0,0,0.6)",
                }}
              />
              <p style={{ color: "var(--muted)", fontSize: "13px", marginTop: "8px" }}>
                श्री महाकालेश्वर ज्ञान मंदिर आश्रम — देववृन्द
              </p>
            </div>
          </div>

          <div style={{ textAlign: "center", marginTop: "26px" }}>
            <a href="#contact" className="btn" style={{ display: "inline-block" }}>
              आश्रम से संपर्क / श्रद्धांजलि
            </a>
          </div>
        </div>
      </section>
{this.state.modalOpen && (
      <div id="modal" className="modal-overlay" role="dialog" aria-modal="true" aria-label="Swami portrait">
      <div className="modal-inner">
        <div className="modal-card">
          <button className="close-btn" id="closeBtn" onClick={this.closeModal}>✕</button>

          <div style={{ position: "relative", display: "flex", alignItems: "center", justifyContent: "center" }}>

            {/* Glow layers */}
            <div className="glow"></div>
            <div className="light-sweep"></div>

            {/* Surya Mandala SVG */}
            <svg
              id="modalSurya"
              className="surya-svg surya-spin"
              viewBox="0 0 600 600"
              preserveAspectRatio="xMidYMid meet"
            >
              <defs>
                <radialGradient id="rg" cx="50%" cy="45%">
                  <stop offset="0%" stopColor="#fff2e6" stopOpacity="0.22" />
                  <stop offset="25%" stopColor="#ffd8a8" stopOpacity="0.18" />
                  <stop offset="60%" stopColor="#ff9933" stopOpacity="0.12" />
                  <stop offset="100%" stopColor="#ff6600" stopOpacity="0" />
                </radialGradient>

                <linearGradient id="sg" x1="0" x2="1">
                  <stop offset="0" stopColor="#ffd699" />
                  <stop offset="1" stopColor="#ff6600" />
                </linearGradient>
              </defs>

              <g transform="translate(300,300)">
                <circle r="120" fill="url(#rg)" />
                <circle r="120" fill="none" stroke="#ffd699" strokeOpacity="0.18" strokeWidth="3" />

                <g stroke="#ffd699" strokeOpacity="0.08" strokeWidth="2">
                  <circle r="160" fill="none" />
                  <circle r="190" fill="none" />
                </g>

                {/* 24 Rays */}
                <g id="raysModal" fill="url(#sg)" opacity="0.95">
                  {[...Array(24)].map((_, i) => (
                    <g transform={`rotate(${i * 15})`} key={i}>
                      <path d="M0,-210 L12,-125 L0,-150 L-12,-125 Z" />
                    </g>
                  ))}
                </g>

                {/* Ellipse Glow */}
                <g fill="#ffd699" opacity="0.07">
                  {[0, 30, 60, 90, 120, 150].map((angle, i) => (
                    <g transform={`rotate(${angle})`} key={i}>
                      <ellipse cx="0" cy="-142" rx="14" ry="32" />
                    </g>
                  ))}
                </g>
              </g>
            </svg>

            {/* Portrait Image */}
            <div style={{ position: "relative", zIndex: 6, display: "flex", alignItems: "center", justifyContent: "center" }}>
              <img
                id="modalPortrait"
                src="images/IMG_5427-removebg-preview.png"
                alt="Swami Brahmanand Saraswati" title="Swami Brahmanand Saraswati"
                style={{
                  width: "360px",
                  height: "480px",
                  objectFit: "contain",
                  display: "block",
                  filter: "drop-shadow(0 40px 120px rgba(0,0,0,0.7))"
                }}
              />
            </div>

          </div>
        </div>
      </div>
    </div>  )}
      </div>
    );
  }
}
